import { hasBooleanValue } from '../../../../utils/NumberUtil'

export default class DtoCMSCategory {
    constructor(obj) {
        this.id = obj.id
        this.title = obj.title
        this.comment = obj.comment
        this.author = obj.author
        this.login = obj.login
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.isNew = obj.isNew || false
        this.displayOnNotificationBar = hasBooleanValue(obj.displayOnNotificationBar) ? obj.displayOnNotificationBar : true
        this.icon = obj.icon || 'event_note'
        this.displayOnMenu = hasBooleanValue(obj.displayOnMenu) ? obj.displayOnMenu : true
        this.menu = obj.menu || 'Communication'
        this.headers = ['name', 'notifBar', 'menu', 'startDate', 'endDate', 'author', 'nullValue']
    }
}